import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ProgressIndicatorSpinnerIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M1.17 9.56A6.78 6.78 0 0 1 1 8h1c0 .45.05.9.15 1.33l-.97.22-.01.01ZM2.53 12.36c-.33-.41-.61-.86-.83-1.33l.9-.43c.19.4.44.79.72 1.14l-.78.62h-.01ZM4.96 14.31c-.47-.23-.92-.51-1.33-.84l.62-.78c.35.28.73.52 1.14.72l-.44.9h.01ZM8 15c-.53 0-1.05-.06-1.56-.17l.22-.97A6.005 6.005 0 0 0 14 8.01c0-3.31-2.69-6-6-6V1c3.86 0 7 3.14 7 7s-3.14 7-7 7Z" />
  </IconWrapper>
)

export default ProgressIndicatorSpinnerIconSmall
